import React from "react";
import { DateRangePicker, DateRangePickerProps } from "rsuite";

import { Label } from "../Label";

const DateRangePickerInput = (props: DateRangePickerProps & { labelTitle: string; labelClassName?: string }) => {
  const { labelTitle, labelClassName, ...pickerProps } = props;

  return (
    <>
      <Label title={labelTitle} className={labelClassName} />
      <DateRangePicker {...pickerProps} />
    </>
  );
};

export default DateRangePickerInput;
